import React from "react";
import ReactDOM from "react-dom";
import "semantic-ui-css/semantic.min.css";
import "react-toastify/dist/ReactToastify.min.css";
import "./css/index";
import App from "./app/layout/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { configureStore, history } from "./app/store/configureStore";
import { ConnectedRouter } from "connected-react-router";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";
import * as serviceWorker from "./serviceWorker.js";
import ScrollToTop from "./app/layout/ScrollToTop";

// creating store from our configuration taking in the reducer
const store = configureStore();
const persistor = persistStore(store);

// const stripePromise = loadStripe(process.env.REACT_APP_PUBLISHABLE_KEY);

// persistor.purge()

const rootEl = document.getElementById("root");

function render() {
  ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConnectedRouter history={history}>
          {/* <Elements stripe={stripePromise}> */}
          <ScrollToTop />
          <App />
          {/* </Elements> */}
        </ConnectedRouter>
      </PersistGate>
    </Provider>,
    rootEl
  );
}

if (module.hot) {
  module.hot.accept("./app/layout/App", function () {
    setTimeout(render);
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

render();
